// @flow
import {
  UPDATE_PORTFOLIO_DATA,
  UPDATE_PORTFOLIO_STATUS
} from '../../actions/portfolios'
import type {
  UPDATE_PORTFOLIO_DATA_TYPE,
  UPDATE_PORTFOLIO_STATUS_TYPE
} from '../../actions/portfolios'

type State = {
  isFetching: boolean,
  portfolioSnapshot: Object[],
  error: null | string
}

type Action =
  | UPDATE_PORTFOLIO_DATA_TYPE
  | UPDATE_PORTFOLIO_STATUS_TYPE

const initialState: State = {
  isFetching: false,
  portfolioSnapshot: [],
  error: null
}

export default function portfoliosReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_PORTFOLIO_DATA: {
      const { portfolioSnapshot } = action.payload
      return {
        ...state,
        portfolioSnapshot
      }
    }
    case UPDATE_PORTFOLIO_STATUS: {
      const { isFetching, error } = action.payload
      return {
        ...state,
        isFetching: isFetching,
        error: error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/portfolios/index.js